import { Component, Vue, Prop } from 'vue-property-decorator';
import { IBatchMessage } from '../../../../../models/radar.listing';
import * as T_T from 'cryface';
import { ListingsRestfulDelegate } from '../../../../../services/DataDelegate/ListingsDelegate/listings.restful.delegate';
import { IAgentMatch } from 'src/models/showing';

@Component
export default class SendNotice extends Vue {
   public title: string = 'SendNotice';
   public listingRestfulDelegate: ListingsRestfulDelegate = new ListingsRestfulDelegate();

   @Prop()
   public row: any;

   public formLine: IBatchMessage = {
      from: '',
      to: [
      ],
      callback: '',
      message: '',
      listing_id: ''
   };

   public indeterminate = true;
   public checkAll = false;

   public formRules = {};

   public async send() {
      this.$store.commit('listingStartFetching');
      const numbers: string[] = [];
      this.formLine.to.map((v: any) => {
         if (v.checked === true) {
            numbers.push(v.phone);
         }
      });
      await this.listingRestfulDelegate.batchSend(numbers, this.formLine.message);
      this.$store.commit('listingEndFetching');
      this.$Notice.success(
         {
            title: 'Succeed',
            desc: `Message Sent.`
         }
      );
   }

   public handleCheckAll() {
      for (let i = 0; i < this.formLine.to.length; i++) {
         this.formLine.to[i].checked = true;
      }
   }

   public handleCancelAll() {
      for (let i = 0; i < this.formLine.to.length; i++) {
         this.formLine.to[i].checked = false;
      }
   }

   public async created() {
      const agents = await this.listingRestfulDelegate.allShowingAgent(this.row.id);
      if (T_T.simpleDetect(agents) && agents.errorCode === 200) {
         agents.data.map((agent: IAgentMatch) => {
            this.formLine.to.push(
               {
                  id: agent.id,
                  name: agent.name,
                  phone: agent.phone.toString(),
                  checked: false
               }
            );
         });
      }
      if (T_T.simpleDetect(this.row.listing_agent_one)) {
         this.formLine.to.push(
            {
               id: '-1',
               name: this.row.listing_agent_one,
               phone: '9022339517',
               checked: false
            }
         );
         this.formLine.from = this.row.listing_agent_one;
      }
      if (T_T.simpleDetect(this.row.listing_agent_two)) {
         this.formLine.to.push(
            {
               id: '-2',
               name: this.row.listing_agent_two,
               phone: '9022339517',
               checked: false
            }
         );
         if (T_T.simpleDetect(this.formLine.from)) { } else {
            this.formLine.from = this.row.listing_agent_two;
         }
      }
      if (T_T.simpleDetect(this.row.notifier_one)) {
         if (T_T.simpleDetect(this.row.notifier_one.id)) {
            this.formLine.to.push(
               {
                  id: '-3',
                  name: `${this.row.notifier_one.first_name} ${this.row.notifier_one.last_name}`,
                  phone: this.row.notifier_one.phone,
                  checked: false
               }
            );
         }
      }
      if (T_T.simpleDetect(this.row.notifier_two)) {
         if (T_T.simpleDetect(this.row.notifier_two.id)) {
            this.formLine.to.push(
               {
                  id: '-4',
                  name: `${this.row.notifier_two.first_name} ${this.row.notifier_two.last_name}`,
                  phone: this.row.notifier_two.phone,
                  checked: false
               }
            );
         }
      }
   }
}
